import { render, staticRenderFns } from "./MatchInfos.vue?vue&type=template&id=4aeeec6b&scoped=true&"
import script from "./MatchInfos.vue?vue&type=script&lang=ts&"
export * from "./MatchInfos.vue?vue&type=script&lang=ts&"
import style0 from "./MatchInfos.vue?vue&type=style&index=0&id=4aeeec6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeeec6b",
  null
  
)

export default component.exports